import type { PointNumber, ResolveFn } from '../types.js';
import { oddsPayoutPass, oddsPayoutDont } from './odds.js';
import { vigOnAmount } from '@casino/core';

const wins = (n: PointNumber, total: number) => total === n;

export const resolveBuy: ResolveFn = (b, roll, _state, rules) => {
  if (b.number === undefined) throw new Error('buy bet missing number');
  if (wins(b.number, roll.total)) {
    const truePayout = oddsPayoutPass(b.amount, b.number);
    // Buy: vig is 5% of the bet amount (you pay to buy true odds on the number).
    const vig = rules.vigPolicy === 'onWin' ? vigOnAmount(b.amount) : 0;
    return { betId: b.id, outcome: 'win', payout: truePayout - vig };
  }
  if (roll.total === 7) return { betId: b.id, outcome: 'lose', payout: 0 };
  return { betId: b.id, outcome: 'continue', payout: 0 };
};

export const resolveLay: ResolveFn = (b, roll, _state, rules) => {
  if (b.number === undefined) throw new Error('lay bet missing number');
  if (roll.total === 7) {
    const truePayout = oddsPayoutDont(b.amount, b.number);
    // Lay: vig is 5% of the win amount (true-odds payout), not the lay stake.
    // This matches casino convention since Lay risks more to win less.
    const vig = rules.vigPolicy === 'onWin' ? vigOnAmount(truePayout) : 0;
    return { betId: b.id, outcome: 'win', payout: truePayout - vig };
  }
  if (wins(b.number, roll.total)) return { betId: b.id, outcome: 'lose', payout: 0 };
  return { betId: b.id, outcome: 'continue', payout: 0 };
};
